import React from 'react'
import { Button, Col, Grid, Icon, Typography } from 'gu-ui-kit'
import { Link } from 'react-router-dom'
import { ROUTES } from 'constants/routes'
import useGeneratePathI18n from 'utils/hooks/useGeneratePathI18n'
import { shallowEqual, useSelector } from 'react-redux'
import { useBreakpoint } from 'utils/hoc/breakpointProvider'
import { useTranslation } from 'react-i18next'
import { SecurityPassword, Status } from 'modules/User/Security/subcomponents'
import styles from 'modules/User/Security/Security.module.scss'

const Security = () => {
  const { t } = useTranslation()
  const pathGen = useGeneratePathI18n()
  const breakpoints = useBreakpoint()

  const {
    initialized = false,
    enabled = false,
    is_2fa_available = false,
  } = useSelector((state) => {
    const combined = { ...state['user/2fa'], ...state['user/profile'] }
    return {
      initialized: combined.initialized,
      enabled: combined.enabled,
      is_2fa_available: combined.is_2fa_available,
    }
  }, shallowEqual)

  return (
    <>
      <Typography
        color={'Label-Primary'}
        component={'h3'}
        variant={'Subtitle-25'}
        className={'margin-bottom-8'}
      >
        {t('user::security.password.heading')}
      </Typography>
      <Typography
        color={'Label-Fifth'}
        variant={'Body-15'}
        className={styles['security__section-summary']}
      >
        {t('user::security.password.summary')}
      </Typography>
      <table className={styles['security__table']}>
        <tbody>
          <tr>
            <td>
              <Grid
                gap={12}
                direction={'column'}
              >
                <Col>
                  <Typography
                    variant={'Body-15'}
                    color={'Label-Fifth'}
                  >
                    {t('user::security.password.label')}
                  </Typography>
                </Col>
                {!breakpoints.fb && (
                  <Col>
                    <SecurityPassword />
                  </Col>
                )}
              </Grid>
            </td>

            {breakpoints.fb && (
              <td>
                <SecurityPassword />
              </td>
            )}

            <td>
              <Button
                variant={'ghost'}
                grey
                component={Link}
                size={'m'}
                to={pathGen(ROUTES.USER_SECURITY_PASSWORD)}
                noLabel={!breakpoints.fb}
                endIcon={<Icon name="arrow-right" />}
              >
                {t('user::security.password.edit')}
              </Button>
            </td>
          </tr>
          {is_2fa_available && initialized && (
            <tr>
              <td>
                <Grid
                  gap={12}
                  direction={'column'}
                >
                  <Col>
                    <Typography
                      variant={'Body-15'}
                      color={'Label-Fifth'}
                    >
                      {t('user::security.2fa.heading')}
                    </Typography>
                  </Col>
                  {!breakpoints.fb && (
                    <Col>
                      <Status
                        enabled={enabled}
                        initialized={initialized}
                      />
                    </Col>
                  )}
                </Grid>
              </td>

              {breakpoints.fb && (
                <td>
                  <Status
                    enabled={enabled}
                    initialized={initialized}
                  />
                </td>
              )}

              <td>
                <Button
                  variant={'ghost'}
                  grey
                  component={Link}
                  size={'m'}
                  to={
                    !enabled ? pathGen(ROUTES.USER_SECURITY_2FA) : pathGen(ROUTES.USER_SECURITY_2FA)
                  }
                  noLabel={!breakpoints.fb}
                  endIcon={<Icon name="arrow-right" />}
                >
                  {!enabled
                    ? t('user::security.2fa.enable_2fa')
                    : t('user::security.2fa.disable_2fa')}
                </Button>
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </>
  )
}

export default Security
